/**
 * Matriz de features por plan. Fuente única de verdad para el front.
 * Debe mantenerse sincronizado con backend/plan_gate.py (PLAN_LIMITS).
 */
export const PLAN_FEATURES = {
  free: {
    label: "Inicial",
    price: 5,
    posts: 10,
    images: 0,
    networks: 1,
    competitors: 0,
    autopilot: false,
    listening: false,
    brands: 1,
    videos: false,
    apiPublic: false,
    marketplace: false,
    seo: false,
  },
  basic: {
    label: "Básico",
    price: 19,
    posts: 100,
    images: 20,
    networks: 3,
    competitors: 0,
    autopilot: false,
    listening: false,
    brands: 1,
    videos: false,
    apiPublic: false,
    marketplace: true,
    seo: true,
  },
  pro: {
    label: "Pro",
    price: 49,
    posts: 500,
    images: 100,
    networks: 5,
    competitors: 3,
    autopilot: true,
    listening: true,
    brands: 1,
    videos: false,
    apiPublic: false,
    marketplace: true,
    seo: true,
  },
  agency: {
    label: "Agencia",
    price: 99,
    posts: Infinity,
    images: Infinity,
    networks: 5,
    competitors: Infinity,
    autopilot: true,
    listening: true,
    brands: 5,
    videos: false, // video es add-on, no incluido por defecto
    apiPublic: true,
    marketplace: true,
    seo: true,
  },
};

export function featuresFor(planKey) {
  return PLAN_FEATURES[planKey] || PLAN_FEATURES.free;
}

/** true si el plan incluye el feature dado (o es add-on comprado vía "+Video"). */
export function planIncludes(planKey, feature, user) {
  const f = featuresFor(planKey);
  // Video es add-on: backend lo setea como user.has_video_addon.
  // Mantenemos compat con `video_addon` por si quedó alguna build vieja.
  if (feature === "videos") {
    if (user?.has_video_addon || user?.video_addon) return true;
    return false;
  }
  if (feature in f) {
    const v = f[feature];
    return typeof v === "boolean" ? v : v > 0;
  }
  return false;
}

/** Red social disponible según plan (ordenadas por prioridad). */
export const NETWORK_PRIORITY = ["twitter", "instagram", "facebook", "linkedin", "tiktok"];

export function allowedNetworks(planKey) {
  const limit = featuresFor(planKey).networks;
  return NETWORK_PRIORITY.slice(0, limit);
}
